import { render, staticRenderFns } from "./SiteNavigation.vue?vue&type=template&id=61483aec"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"
import style0 from "./SiteNavigation.vue?vue&type=style&index=0&id=61483aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports